import React from "react";
import { heroShowreelDesktopId, heroShowreelMobileId, bunnyEmbed } from "../data/categoriesData";

// Hero showreel via Bunny Stream. On desktop we play the wide cut; on
// mobile (when the client supplies a vertical cut) we swap in the
// mobile-optimised Bunny video so titles don't get cropped. Until then,
// the desktop cut runs on both — sized with object-cover-equivalent
// transforms so the player chrome is cropped offscreen.
export const Hero = () => {
  const scrollToWork = () => {
    document.querySelector("#work")?.scrollIntoView({ behavior: "smooth" });
  };

  const desktopSrc = bunnyEmbed(heroShowreelDesktopId, { autoplay: true, muted: true, loop: true });
  const mobileSrc = heroShowreelMobileId
    ? bunnyEmbed(heroShowreelMobileId, { autoplay: true, muted: true, loop: true })
    : desktopSrc;

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden flex items-end bg-black"
    >
      <div className="absolute inset-0">
        {/* Mobile-specific embed (hidden on md+); we render both at all
            times so neither has to reload on a viewport change. */}
        <div className="md:hidden absolute inset-0 overflow-hidden">
          <iframe
            data-testid="hero-iframe-mobile"
            src={mobileSrc}
            title="Momenta Studios Showreel (mobile)"
            allow="autoplay; encrypted-media"
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"
            style={{
              width: "max(177.78vh, 100%)",
              height: "max(56.25vw, 100%)",
              border: 0,
            }}
          />
        </div>
        <div className="hidden md:block absolute inset-0 overflow-hidden">
          <iframe
            data-testid="hero-iframe-desktop"
            src={desktopSrc}
            title="Momenta Studios Showreel"
            allow="autoplay; encrypted-media"
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"
            style={{
              width: "max(177.78vh, 100%)",
              height: "max(56.25vw, 100%)",
              border: 0,
            }}
          />
        </div>
        {/* Readability gradients on the right side where the copy lives */}
        <div className="absolute inset-y-0 right-0 w-full md:w-1/2 bg-gradient-to-l from-black via-black/55 to-transparent" />
        <div className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-black/55 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-black/85 to-transparent md:hidden" />
      </div>

      <div className="relative z-10 w-full pb-16 sm:pb-20 lg:pb-24">
        <div className="max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-14">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-end">
            <div className="md:col-span-5 md:col-start-7 md:text-right reveal reveal-delay-2">
              <p
                data-testid="hero-tagline"
                className="hidden md:block text-white text-base sm:text-lg lg:text-xl font-light leading-relaxed drop-shadow-[0_2px_18px_rgba(0,0,0,0.85)] md:ml-auto max-w-md md:max-w-lg"
              >
                We craft bold, cinematic content for brands that refuse to
                blend in. Product launches, brand films, social campaigns.
                Every second, a story.
              </p>
              <button
                data-testid="hero-cta-work"
                onClick={scrollToWork}
                className="group mt-6 sm:mt-8 inline-flex items-center gap-4 border border-white/40 hover:border-white text-white px-6 py-4 text-[11px] tracking-[0.3em] uppercase transition-all backdrop-blur-sm bg-black/25 hover:bg-black/45"
              >
                <span>View the Work</span>
                <span className="inline-block transition-transform duration-500 group-hover:translate-x-1">↓</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
